// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x7IT7","footer":"styles_footer__3Kak0"};